/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import BaseCom from "../BaseCom";

export default class Roundup extends BaseCom {

    componentDidMount() {
        this.fillItem('/api/dashboard/roundup?dt=' + Globals.toISODateString(new Date()), 'item');
    }

    render() {
        return <div>
            <table className="table table-striped">
            <thead>
                <tr>
                    <th>Patient Conversion Status</th>
                    <th>Daily</th>
                    <th>Weekly</th>
                    <th>MTD</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Insurance Approvals</td>
                    <td>{this.state.item?.insuranceApprovals?.daily}</td>
                    <td>{this.state.item?.insuranceApprovals?.weekly}</td>
                    <td>{this.state.item?.insuranceApprovals?.mtd}</td>
                </tr>
                <tr>
                    <td>Clinical Approvals *</td>
                    <td>{this.state.item?.clinicalApprovals?.daily}</td>
                    <td>{this.state.item?.clinicalApprovals?.weekly}</td>
                    <td>{this.state.item?.clinicalApprovals?.mtd}</td>
                </tr>
                <tr>
                    <td>Converted Patients</td>
                    <td>{this.state.item?.convertedPatients?.daily}</td>
                    <td>{this.state.item?.convertedPatients?.weekly}</td>
                    <td>{this.state.item?.convertedPatients?.mtd}</td>
                </tr>
                <tr>
                    <td>Added to Calendar</td>
                    <td>{this.state.item?.addedToCalendar?.daily}</td>
                    <td>{this.state.item?.addedToCalendar?.weekly}</td>
                    <td>{this.state.item?.addedToCalendar?.mtd}</td>
                </tr>
            </tbody>
        </table>
        <p className="note"><i>* Clinical Approvals date was not previously tracked. Tracking begins on 8/19/2024.</i></p>
        </div>;
    }
}